import { render } from "./home-client.vue?vue&type=template&id=98f1043e"
import script from "./home-client.vue?vue&type=script&lang=js"
export * from "./home-client.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__